// Direct CDN fetchers for materialized page content. These bypass the write API
// entirely — they hit CloudFront directly, which serves from S3 with sub-20ms latency.
//
// The "auth" model: knowing the URL grants access. Page URLs are content-versioned with
// ULIDs (256 bits of entropy total) and only listed in tree.json, which IS auth-protected.
// So you can only get a page URL by being authenticated and reading the tree first.

export interface MaterializedPage {
  id: string;
  version: string;
  title: string;
  icon: string | null;
  cover: string | null;
  parentId: string | null;
  sortOrder: number;
  content: unknown;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
}

/** Fetches a page's materialized JSON directly from CloudFront. */
export async function fetchPageContent(
  pageId: string,
  version: string,
): Promise<MaterializedPage> {
  const url = `/pages/${pageId}/${version}.json`;
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`Failed to fetch page ${pageId}@${version}: ${res.status}`);
  }
  return (await res.json()) as MaterializedPage;
}
